var _polygon, _polygon2, _circle, _rect, _path, _path2, _rect2, _path3, _circle2, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffroad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "40.5,29.2 40.5,34.6 46.6,39.1 52.9,39.1 54.6,29.2  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "12.4,30.5 27.6,30.5 27.6,36.3 23.1,37.4 19.5,39.7 16,34.2 12.4,34.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 48.9,
    cy: 37.9,
    r: 5.1
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9,
    cy: 37.9,
    r: 3.2
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 48.9,
    cy: 37.9,
    r: 1.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 33.6,
    width: 4.5,
    height: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6,33.8L7.6,33.8c0-0.2,0.2-0.4,0.4-0.4h1v0.7H8C7.8,34.1,7.6,33.9,7.6,33.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7,27.4v-9.9c0-0.3,0.2-0.5,0.5-0.5h10.1c0.7,0,1.3,0.5,1.6,1.1c0.1,0,0.1,0.1,0.1,0.2l1.7,7.1l0.1,0.4 h13.9c1.1,0,2,0.9,2,2v2.3h-8.6l-1,1.3l-0.2,0.3l-3,3.9l-0.5,0.6l-0.2,0.3H25.1L25,36.3l-2.2-3.9l-0.3-0.6c-0.1,0-0.1-0.1-0.1-0.1 c-0.2-0.5-0.7-0.7-1.2-0.7h-5.1c-0.5,0-0.9,0.3-1.2,0.7l0,0l-0.4,0.7l-1.2,1.8l-0.2,0.4H8.9v-7.2C8.9,27.4,24.7,27.4,24.7,27.4z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1,
    y: 26.8,
    width: 2.5,
    height: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4,27.5c0-2.4,2-4.3,4.4-4.4l0,0v4.4H20.4L20.4,27.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 18.7,
    cy: 37.9,
    r: 5.1
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7,
    cy: 37.9,
    r: 3.2
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 18.7,
    cy: 37.9,
    r: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41,36.8c-0.2-0.1-0.2-0.4-0.1-0.6l4.9-6.2c0-0.1,0.2-0.2,0.3-0.2h8.5c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4h-8.3 l-4.8,6c0,0.1-0.2,0.2-0.3,0.2C41.1,36.8,41,36.7,41,36.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5,30.7v-6.6c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2v6.6c0,1.1-0.9,2-2,2l0,0C5.9,32.7,5,31.8,5,30.7z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1,33V18.1h0.2V33c0,0.5,0.4,0.9,0.9,0.9h9.7c0.5,0,0.9-0.4,0.9-0.9l0-7.1c0-0.4-0.1-0.8-0.4-1.1l-1.3-1.7l0.2-0.1 l1.3,1.7c0.2,0.4,0.4,0.8,0.4,1.3l0,7c0,0.6-0.5,1.1-1.1,1.1h-9.7C26.6,34.1,26.1,33.6,26.1,33z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M35.1,18.1h-7.4c-0.4,0-0.7,0.3-0.7,0.7v5c0,0.4,0.3,0.7,0.7,0.7h9c0.3,0,0.5-0.3,0.4-0.5L36,18.7 C35.9,18.4,35.6,18.1,35.1,18.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffroad);
export default __webpack_public_path__ + "static/media/offroad.ab18983a67ee7f022b1ad58c9eca3efe.svg";
export { ForwardRef as ReactComponent };